import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid, IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import ConfirmationModal from "views/components/ConfirmationModal";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "../../../components/UpdateUi/SubHeader/SubHeader";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal"; 
import { deviationDataConfig } from "assets/properties/properties";
import { toastAction } from "assets/properties/properties";
import { removeUnderscoresAndCapitalize } from "utils/Utils";

const Deviation = () => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteUserId, setDeleteUserId] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");

  const {
    label,
    button,
    searchLabel,
    createUrl,
    viewUrl,
    updateUrl,
    confirmationHeader,
    confirmationMsg,
    successMsg,
    tableColumns,
  } = deviationDataConfig;

  const handleCreate = () => {
    navigate(createUrl);
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.DEVIATION_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate(toastAction?.error, result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  };

  const onSearchChange = (event) => {
    const val = event.target.value.toLowerCase();
    const filteredData = rawData.filter((row) => {
      return (
        row.code?.toLowerCase().includes(val) ||
        row.ruleType?.toLowerCase().includes(val) ||
        row.unit?.toLowerCase().includes(val) ||
        row.designation?.toLowerCase().includes(val) 
      );
    });
    parseIndicatorData(filteredData);
  };

  const parseIndicatorData = (data) => {
    let reportData = [];
    data.forEach((deviationData, index) => {
      let row = {
        code: deviationData?.code,
        ruleType: deviationData?.ruleType,
        unit: deviationData?.unit,
        designation: removeUnderscoresAndCapitalize(deviationData?.designation?.toLowerCase()),
        level: deviationData?.level,
        minValue: deviationData?.minValue,
        maxValue: deviationData?.maxValue,
        status: deviationData.active ? "Active" : "Inactive",
        actions: getIcons(deviationData.id, deviationData.ruleType),
        viewCode: deviationData.id,
      };
      reportData.push(row);
    });
    setSelectedTableData(reportData);
    setTableData(reportData);
  };

  const onClickUpdateData = (id) => {
    navigate(`${updateUrl}${id}`);
  };

  const onClickViewData = (id) => {
    navigate(`${viewUrl}${id}`);
  };

  const onClickDeleteData = (id) => {
    setConfirmationModalHeader(confirmationHeader);
    setConfirmationModalMsg(confirmationMsg);
    setDeleteUserId(id);
    setConfirmationModal(true);
  };
  const getIcons = (id, rule) => (
    <>
      <IconButton
        aria-label="Edit Deviation"
        onClick={(e) => {
          e.stopPropagation();
          onClickUpdateData(id);
        }}
      >
        <EditIcon />
      </IconButton>
      <IconButton
        aria-label="Delete Deviation"
        onClick={(e) => {
          e.stopPropagation();
          onClickDeleteData(id);
        }}
      >
        <DeleteIcon />
      </IconButton>
    </>
  );

  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteUserId("");
  };
  const handlePositiveResponse = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.DEVIATION_DELETE + deleteUserId,
      method: "DELETE",
      authToken,
    });
    setCallInProgress(false);
    handleNegativeResponse();
    if (res?.data?.error_code) {
      toastUpdate(toastAction?.error, res?.data?.user_description, true);
    } else {
      toastUpdate(toastAction?.success, successMsg, true);
      GetData();
    }
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={label}
          button1={button}
          button1click={handleCreate}
          onSearchChange={onSearchChange}
          search
          searchLabel={searchLabel}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <TableContainer component={Paper} elevation={0}>
          <ColumnGroupingTable
            columns={tableColumns}
            rows={selectedTableData}
            onClickViewData={onClickViewData}
          />
        </TableContainer>
      </Grid>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

Deviation.propTypes = {
  classes: PropTypes.object,
};

export default Deviation;
